/** A filter as the gateway reads it in a query string: a flag that is on is `true`, a number its digits. */
type Sent<V> = V extends boolean ? "true" : V extends number ? string : V;

/**
 * The query string of a list and of its count from the filters of a screen: only the ones that are set. The filters
 * have the names of the input of the list, so one added to their type reaches the gateway without a line here. The
 * paging of the input (`page`, `limit`) travels the same way.
 */
export function filterQuery<F extends Record<string, string | number | boolean | undefined>>(filters: F) {
  return Object.fromEntries(
    Object.entries(filters).flatMap(([name, value]) =>
      value ? [[name, value === true ? "true" : String(value)]] : [],
    ),
  ) as { [K in keyof F]?: Sent<NonNullable<F[K]>> };
}
